<template>
  <v-dialog v-model="isEditComment" max-width="800" persistent>
    <v-card class="quick-view">
      <v-card-title class="font-weight-bold px-5">
        Chỉnh sửa nhận xét
        <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-3">
        <v-textarea
          v-model="newComment"
          hint="Không được để trống phần nhận xét"
        ></v-textarea>
      </v-card-text>
      <v-card-actions class="pa-5 group-btn-comment">
        <v-btn @click="closeModal()" color="#E0E0E0">
          Hủy
        </v-btn>
        <v-btn outlined color="pink" @click="saveAndShare()">
          Lưu & chia sẻ với HS
        </v-btn>
        <v-btn color="error" @click="saveComment()">
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="css" scoped>
.group-btn-comment {
  display: flex;
  float: right;
}
</style>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    isEditComment: {
      default: () => false,
    },
    itemReview: {
      type: Object,
      default: () => ({}),
    },
    subjectId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      newComment: '',
    };
  },
  created() {
    //
  },
  watch: {
    itemReview() {
      this.newComment = this.itemReview.comment_content;
    },
  },
  methods: {
    ...mapActions('student_care', ['sendComment']),
    closeModal() {
      this.$emit('closeModalEditComment');
    },
    saveAndShare() {
      if (this.newComment === '') {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không được để trống phần nhận xét!',
        });
        return;
      }
      const params = {
        id: this.itemReview.id,
        comment_content: this.newComment,
      };
      Bus.$emit('open-share-comment', params);
    },
    async saveComment() {
      if (this.newComment === '') {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không được để trống phần nhận xét!',
        });
        return;
      }
      if (!this.itemReview?.id) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không tìm thấy bản ghi nhận xét, vui lòng thử lại!',
        });
        return;
      }
      const params = {
        id: this.itemReview?.id,
        comment_content: this.newComment,
      };
      const res = await this.sendComment(params);
      if (!res) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra khi gửi nhận xét cho học sinh!',
        });
        return;
      }
      this.$swal({
        type: 'success',
        title: 'Thành công!',
        text: 'Đã lưu nhận xét!',
      }).then(() => {
        this.closeModal();
        Bus.$emit('load-right-data', { subjectId: this.subjectId });
        Bus.$emit('lesson-ieltsy');
      });
    },
  },
};
</script>
